export const SENTRY_RELEASE = process.env.NODE_ENV === 'production' ? process.env.npm_package_version : 'development'
export const COMMON_SENTRY_CONFIG = {
  beforeSend: (event: any): any => {
    // https://github.com/getsentry/sentry-javascript/issues/3440
    // filter out UnhandledRejection errors that have no information
    if (
      event !== undefined &&
      event.exception !== undefined &&
      event.exception.values !== undefined &&
      event.exception.values.length === 1
    ) {
      const e = event.exception.values[0]
      if (e.type === 'UnhandledRejection' && e.value === 'Non-Error promise rejection captured with value: ') {
        return null
      }
    }
  },
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  enabled: process.env.NODE_ENV === 'production',
  enableTracing: true,
  environment: process.env.NEXT_PUBLIC_WASTEPAY_ENV,
  ignoreErrors: [
    // https://github.com/trezor/trezor-suite/issues/5730
    // https://forum.sentry.io/t/resizeobserver-loop-limit-exceeded/8402/5
    // https://stackoverflow.com/questions/63020810/what-is-best-way-in-javascript-to-stop-throwing-resizeobserver-loop-limit-excee
    'ResizeObserver loop limit exceeded',
    // https://stackoverflow.com/questions/76187282/react-resizeobserver-loop-completed-with-undelivered-notifications
    'ResizeObserver loop completed with undelivered notifications.'
  ],
  release: SENTRY_RELEASE
}
